
const BackendTranslation = {

    // Defaults
    _defaultOnError: {
        pt_br: "Ocorreu um erro de comunicação com o servidor, tente novamente mais tarde ou contate o suporte para análise",
        en_us: "There was a communication error with the server, please try again later or contact support for review",
        es_es: "Hubo un error de comunicación con el servidor, intente nuevamente más tarde o comuníquese con el soporte para una revisión"
    },

    _defaultOnSuccess: {
        pt_br: "Operação realizada com sucesso",
        en_us: "Operation carried out successfully",
        es_es: "Operación realizada con éxito"
    },

    _defaultOnRequiredFields: {
        pt_br: "Preencha todos os campos obrigatórios para prosseguir",
        en_us: "Fill in all the required fields to proceed",
        es_es: "Rellene todos los campos obligatorios para continuar"
    },


    // Access Profiles
    _accessProfilesOnConflictAddEdit: {
        pt_br: "Perfil de acesso informado já possui cadastro",
        en_us: "Access profile informed already has a registration",
        es_es: "Perfil de acceso informado ya tiene registro"
    },

    _accessProfilesOnConflictRemove: {
        pt_br: "Perfil de acesso possui usuários vinculados",
        en_us: "Access profile has linked users",
        es_es: "El perfil de acceso tiene usuarios vinculados"
    },

    _accessProfilesOnSuccessAdd: {
        pt_br: "Perfil de acesso adicionado",
        en_us: "Access profile added",
        es_es: "Perfil de acceso agregado"
    },

    _accessProfilesOnSuccessEdit: {
        pt_br: "Perfil de acesso alterado",
        en_us: "Access profile changed",
        es_es: "Perfil de acceso cambiado"
    },

    _accessProfilesOnSuccessRemove: {
        pt_br: "Perfil de acesso excluído",
        en_us: "Access profile deleted",
        es_es: "Perfil de acceso eliminado"
    },

    _accessProfilesOnNotFound: {
        pt_br: "Perfil de acesso não encontrado",
        en_us: "Access profile not found",
        es_es: "Perfil de acceso no encontrado"
    },


    // Auth
    _authLoginOnError: {
        pt_br: "Usuário e/ou senha digitados são inválidos",
        en_us: "Username and/or password entered are invalid",
        es_es: "El nombre de usuario y/o contraseña ingresados no son válidos"
    },
    
    _authLogoutOnError: {
        pt_br: "Ocorreu um problema ao tentar encerrar a sessão",
        en_us: "There was a problem trying to end a session",
        es_es: "Hubo un problema al intentar finalizar una sesión"
    },

    _authRecoveryPasswordOnSuccess: {
        pt_br: "E-mail de recuperação de senha enviado",
        en_us: "Password recovery email sent",
        es_es: "Correo electrónico de recuperación de contraseña enviado"
    },


    // Departments
    _departmentsOnConflictAddEdit: {
        pt_br: "Departamento informado já possui cadastro",
        en_us: "Department informed already has a registration",
        es_es: "Departamento informado ya tiene registro"
    },

    _departmentsOnConflictRemove: {
        pt_br: "Ocorreu um erro ao tentar excluir o departamento",
        en_us: "An error occurred when trying to delete the department",
        es_es: "Se produjo un error al intentar eliminar el departamento"
    },

    _departmentsOnSuccessAdd: {
        pt_br: "Departamento adicionado",
        en_us: "Department added",
        es_es: "Departamento agregado"
    },

    _departmentsOnSuccessEdit: {
        pt_br: "Departamento alterado",
        en_us: "Department changed",
        es_es: "Departamento cambiado"
    },

    _departmentsOnSuccessRemove: {
        pt_br: "Departamento excluído",
        en_us: "Department deleted",
        es_es: "Departamento eliminado"
    },

    _departmentsOnNotFound: {
        pt_br: "Departamento não encontrado",
        en_us: "Department not found",
        es_es: "Departamento no encontrado"
    },


    // Enterprises
    _enterprisesOnConflictAddEdit: {
        pt_br: "Empreendimento informado já possui cadastro",
        en_us: "Enterprise informed already has a registration",
        es_es: "Empresa informado ya tiene registro"
    },

    _enterprisesOnConflictRemove: {
        pt_br: "Empreendimento possui usuários vinculados",
        en_us: "Enterprise has linked users",
        es_es: "El empresa tiene usuarios vinculados"
    },

    _enterprisesOnSuccessAdd: {
        pt_br: "Empreendimento adicionado",
        en_us: "Enterprise added",
        es_es: "Empresa agregada"
    },

    _enterprisesOnSuccessEdit: {
        pt_br: "Empreendimento alterado",
        en_us: "Enterprise changed",
        es_es: "Empresa cambiada"
    },

    _enterprisesOnSuccessRemove: {
        pt_br: "Empreendimento excluído",
        en_us: "Enterprise deleted",
        es_es: "Empresa eliminada"
    },

    _enterprisesOnSuccessTestDatabaseConnection: {
        pt_br: "Conexão com banco de dados realizada",
        en_us: "Database connection performed",
        es_es: "Conexión a base de datos realizada"
    },

    _enterprisesOnErrorTestDatabaseConnection: {
        pt_br: "Não foi possível conectar-se com o banco de dados",
        en_us: "Unable to connect to the database",
        es_es: "No se puede conectar a la base de datos"
    },

    _enterprisesOnSuccessTestApiConnection: {
        pt_br: "Conexão com API realizada",
        en_us: "API connection performed",
        es_es: "Conexión a API realizada"
    },

    _enterprisesOnErrorTestApiConnection: {
        pt_br: "Não foi possível conectar-se com a API",
        en_us: "Unable to connect to API",
        es_es: "No se puede conectar a la API"
    },

    _enterprisesOnNotFound: {
        pt_br: "Empreendimento não encontrado",
        en_us: "Enterprise not found",
        es_es: "Empresa no encontrada"
    },


    // Governance Items
    _governanceItemsOnConflictAddEdit: {
        pt_br: "Item de governança informado já possui cadastro",
        en_us: "Governance item informed already has a registration",
        es_es: "Elemento de gobernanza informado ya tiene registro"
    },

    _governanceItemsOnConflictRemove: {
        pt_br: "Ocorreu um erro ao tentar excluir o item de governança",
        en_us: "An error occurred when trying to delete the governance item",
        es_es: "Se produjo un error al intentar eliminar el elemento de gobernanza"
    },

    _governanceItemsOnSuccessAdd: {
        pt_br: "Item de governança adicionado",
        en_us: "Governance item added",
        es_es: "Elemento de gobernanza agregado"
    },

    _governanceItemsOnSuccessEdit: {
        pt_br: "Item de governança alterado",
        en_us: "Governance item changed",
        es_es: "Elemento de gobernanza cambiado"
    },

    _governanceItemsOnSuccessRemove: {
        pt_br: "Item de governança excluído",
        en_us: "Governance item deleted",
        es_es: "Elemento de gobernanza eliminado"
    },

    _governanceItemsOnNotFound: {
        pt_br: "Item de governança não encontrado",
        en_us: "Governance item not found",
        es_es: "Elemento de gobernanza no encontrado"
    },


    // Governance Module
    _governanceModuleOnSuccessChangeDoNotDisturb: {
        pt_br: "Status \"não perturbe\" da UH alterado",
        en_us: "Changed room \"do not disturb\" status",
        es_es: "Cambio del estado \"no molestar\" de la habitación"
    },

    _governanceModuleOnForbiddenChangeDoNotDisturb: {
        pt_br: "Usuário não possui ID do parceiro válido",
        en_us: "User does not have a valid partner ID",
        es_es: "El usuario no tiene una identificación de socio válida"
    },

    _governanceModuleOnSuccessChangeGovernanceStatus: {
        pt_br: "Status de governança da UH alterado",
        en_us: "Changed room governance status",
        es_es: "Se cambió el estado de gobierno de la sala"
    },

    _governanceModuleOnForbiddenChangeGovernanceStatus: {
        pt_br: "Usuário não possui ID do parceiro válido",
        en_us: "User does not have a valid partner ID",
        es_es: "El usuario no tiene una identificación de socio válida"
    },

    _governanceModuleOnSuccessChangeReservationObservations: {
        pt_br: "Observações da reserva alteradas",
        en_us: "Changed booking remarks",
        es_es: "Observaciones de la reserva modificada"
    },

    _governanceModuleOnForbiddenChangeReservationObservations: {
        pt_br: "Usuário não possui ID do parceiro válido",
        en_us: "User does not have a valid partner ID",
        es_es: "El usuario no tiene una identificación de socio válida"
    },

    _governanceModuleOnSuccessChangeRoomObservations: {
        pt_br: "Observações da UH alteradas",
        en_us: "Changed room remarks",
        es_es: "Observaciones de la habitacion modificada"
    },

    _governanceModuleOnForbiddenChangeRoomObservations: {
        pt_br: "Usuário não possui ID do parceiro válido",
        en_us: "User does not have a valid partner ID",
        es_es: "El usuario no tiene una identificación de socio válida"
    },

    _governanceModuleOnSuccessLaunchPointOfSaleItems: {
        pt_br: "Itens do ponto de venda lançados",
        en_us: "Point of sale items successfully launched",
        es_es: "Lanzamiento con éxito de artículos de punto de venta"
    },

    _governanceModuleOnErrorPointOfSaleNotFound: {
        pt_br: "Ponto de venda não encontrado",
        en_us: "Point of sale not found",
        es_es: "Punto de venta no encontrado"
    },

    _governanceModuleOnErrorLaunchPointOfSaleItems: {
        pt_br: "Ocorreu um erro ao tentar lançar os itens do ponto de venda",
        en_us: "An error occurred when trying to post the items from the point of sale",
        es_es: "Se ha producido un error al intentar contabilizar los artículos desde el punto de venta"
    },

    _governanceModuleOnSuccessRemoveRoomBlocking: {
        pt_br: "Bloqueio da UH removido",
        en_us: "Room blocking removed",
        es_es: "Bloqueo de la habitación eliminado"
    },

    _governanceModuleOnForbiddenRemoveRoomBlocking: {
        pt_br: "Usuário não possui ID do parceiro válido",
        en_us: "User does not have a valid partner ID",
        es_es: "El usuario no tiene una identificación de socio válida"
    },

    _governanceModuleOnSuccessAddRoomBlocking: {
        pt_br: "Bloqueio da UH adicionado",
        en_us: "Room blocking added",
        es_es: "Bloqueo de la habitación agregado"
    },

    _governanceModuleOnForbiddenAddRoomBlocking: {
        pt_br: "Usuário não possui ID do parceiro válido",
        en_us: "User does not have a valid partner ID",
        es_es: "El usuario no tiene una identificación de socio válida"
    },

    _governanceModuleOnSuccessChangeExecutionPriority: {
        pt_br: "Prioridade de execução da UH alterada",
        en_us: "Changed room execution priority",
        es_es: "Prioridad de ejecución de la habitación modificada"
    },

    _governanceModuleOnForbiddenChangeExecutionPriority: {
        pt_br: "Usuário não possui ID do parceiro válido",
        en_us: "User does not have a valid partner ID",
        es_es: "El usuario no tiene una identificación de socio válida"
    },


    // My Profile
    _myProfileOnSuccessPreferences: {
        pt_br: "Preferências alteradas",
        en_us: "Changed preferences",
        es_es: "Preferencias modificadas"
    },

    _myProfileOnErrorUpdateRecentAccess: {
        pt_br: "Ocorreu um erro ao tentar salvar os dados de navegação",
        en_us: "An error occurred when trying to save the navigation data",
        es_es: "Se ha producido un error al intentar guardar los datos de navegación"
    },

    _myProfileOnNotAcceptableChangePassword: {
        pt_br: "Senha atual incorreta",
        en_us: "Incorrect current password",
        es_es: "Contraseña actual incorrecta"
    },

    _myProfileOnPreconditionFailedChangePassword: {
        pt_br: "Novas senhas digitadas não conferem",
        en_us: "New passwords entered do not match",
        es_es: "Las nuevas contraseñas ingresadas no coinciden"
    },

    _myProfileOnSuccessChangePassword: {
        pt_br: "Senha alterada",
        en_us: "Changed password",
        es_es: "Contraseña cambiada"
    },

    _myProfileChangeDataOnSuccess: {
        pt_br: "Informações alteradas",
        en_us: "Changed information",
        es_es: "Información modificada"
    },


    // Service Order
    _serviceOrdersOnErrorAdd: {
        pt_br: "Erro ao tentar adicionar uma ordem de serviço",
        en_us: "Error when trying to add a service order",
        es_es: "Error al intentar añadir una orden de servicio"
    },

    _serviceOrdersOnErrorUpdate: {
        pt_br: "Erro ao tentar alterar a ordem de serviço",
        en_us: "Error when trying to update service order",
        es_es: "Error al intentar modificar la orden de trabajo"
    },

    _serviceOrdersOnSuccessAdd: {
        pt_br: "Ordem de serviço adicionada",
        en_us: "Service order added",
        es_es: "Orden de servicio agregada"
    },

    _serviceOrdersOnSuccessUpdateStatus: {
        pt_br: "Status da ordem de serviço alterado",
        en_us: "Service order status changed",
        es_es: "Estado de la orden de servicio cambiado"
    },

    _serviceOrdersOnSuccessUpdatePriority: {
        pt_br: "Prioridade da ordem de serviço alterada",
        en_us: "Service order priority changed",
        es_es: "prioridad de la orden de servicio cambiada"
    },

    _serviceOrdersOnSuccessUpdateDepartment: {
        pt_br: "Departamento da ordem de serviço alterado",
        en_us: "Service order department changed",
        es_es: "Departamento de la orden de servicio cambiado"
    },

    _serviceOrdersOnSuccessUpdateResponsible: {
        pt_br: "Responsável da ordem de serviço alterado",
        en_us: "Service order responsible changed",
        es_es: "Responsable de la orden de servicio cambiado"
    },

    _serviceOrdersOnSuccessUpdateStartDate: {
        pt_br: "Data de inpicio da ordem de serviço alterada",
        en_us: "Service order start date changed",
        es_es: "Fecha de inicio de la orden de servicio cambiada"
    },

    _serviceOrdersOnSuccessUpdateEstimatedCompletionDate: {
        pt_br: "Data de conclusão estimada da ordem de serviço alterada",
        en_us: "Service order estimated completion date changed",
        es_es: "Fecha estimada de finalización de la orden de servicio cambiada"
    },

    _serviceOrdersOnNotFound: {
        pt_br: "Ordem de serviço não encontrada",
        en_us: "Service order not found",
        es_es: "Orden de servicio no encontrado"
    },


    // Service Order Comment
    _serviceOrderCommentsOnErrorAdd: {
        pt_br: "Erro ao tentar adicionar um comentário na ordem de serviço",
        en_us: "Error when trying to add a comment in the service order",
        es_es: "Error al intentar añadir un comentario a la orden de servicio"
    },

    _serviceOrderCommentsOnErrorEdit: {
        pt_br: "Erro ao tentar alterar um comentário na ordem de serviço",
        en_us: "Error when trying to change a comment in the service order",
        es_es: "Error al intentar modificar un comentario en la orden de servicio"
    },
    
    _serviceOrderCommentsOnSuccessAdd: {
        pt_br: "Comentário adicionado",
        en_us: "Comment added",
        es_es: "Comentario agregado"
    },
    
    _serviceOrderCommentsOnSuccessEdit: {
        pt_br: "Comentário alterado",
        en_us: "Comment changed",
        es_es: "Comentario cambiado"
    },
    
    _serviceOrderCommentsOnNotFound: {
        pt_br: "Comentário não encontrado",
        en_us: "Comment not found",
        es_es: "Comentario no encontrado"
    },

    
    // System Settings
    _systemSettingsOnSuccessEdit: {
        pt_br: "Configuração alterada",
        en_us: "Setting changed",
        es_es: "Configuración cambiado"
    },

    _systemSettingsOnSuccessTestSendingEmail: {
        pt_br: "Verifique se o e-mail de teste encontra-se em sua caixa de entrada (ou spam)",
        en_us: "Check if the test email is in your inbox (or spam)",
        es_es: "Verifique si el correo electrónico de prueba está en su bandeja de entrada (o spam)"
    },

    _systemSettingsOnErrorTestSendingEmail: {
        pt_br: "Não foi possível enviar o e-mail de teste",
        en_us: "Unable to send test email",
        es_es: "No se puede enviar el correo electrónico de prueba"
    },


    // Users
    _usersOnConflictAddEdit: {
        pt_br: "Usuário informado já possui cadastro",
        en_us: "User informed already has a registration",
        es_es: "Usuario informado ya tiene registro"
    },

    _usersOnSuccessAdd: {
        pt_br: "Usuário adicionado",
        en_us: "User added",
        es_es: "Usuario agregado"
    },

    _usersOnSuccessEdit: {
        pt_br: "Usuário alterado",
        en_us: "User changed",
        es_es: "Usuario cambiado"
    },

    _usersOnSuccessRemove: {
        pt_br: "Usuário excluído",
        en_us: "User deleted",
        es_es: "Usuario eliminado"
    },

    _usersOnNotFound: {
        pt_br: "Usuário não encontrado",
        en_us: "User not found",
        es_es: "Usuario no encontrado"
    },
}

export default BackendTranslation;